import React from 'react';
import { useAutoScrollPage } from './AutoScrollPage';
import { TermsPoliciesContainer } from './TermsPoliciesContainer';

export const PolicyPage = () => {
    const { scrollToHash } = useAutoScrollPage();

    return <TermsPoliciesContainer type='policies' onContentLoaded={scrollToHash} />;
}